<template>
  <PlantUserForm :submit="submit" :cancel="cancel" />
</template>

<script>
import CreateView from '@/mixins/createView';
import ResourceService from '@/services/resources/plant_users_service';

export default {
  mixins: [CreateView],
  components: {
    PlantUserForm: () => import('@/components/forms/PlantUserForm.vue'),
  },
  data() {
    return {
      urlFragment: 'plant-users',
      resourceService: ResourceService,
    };
  },
};
</script>
